import { Column, Entity, Unique } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('client_location_count_city')
@Unique('uq_client_loc_count_city_state', ['city', 'state'])
export class ClientLocationCountCityEntity extends BaseEntity {
	@Column('varchar', { name: 'city', length: 255 })
	public city!: string;

	@Column('varchar', { name: 'state', length: 10 })
	public state!: string;

	@Column('int', { name: 'client_count', unsigned: true, default: 0 })
	public clientCount!: number;
}
